"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@local/utils/src/cn";
import { usePopupState } from "../hooks/usePopupState";
import { getT } from "@local/i18n/src/t";
import type { Language } from "@local/i18n/src/languages";
import { reviews as reviewsCatalog } from "@local/i18n/src/catalogs/reviews";
interface VerifiedBadgeProps {
  businessName: string;
  className?: string;
  language?: Language;
}

/**
 * Displays a verified badge with an information popup explaining what "verified" means.
 * Includes a link to Trustpilot's trust page for more information.
 */
export const VerifiedBadge = t0 => {
  const $ = _c(6);
  const {
    businessName,
    className,
    language: t1
  } = t0;
  const language = t1 === undefined ? "en" : t1;
  const t = getT(language, {
    reviews: reviewsCatalog
  });
  const {
    showPopup,
    setShowPopup,
    containerRef,
    handleMouseEnter,
    handleMouseLeave
  } = usePopupState();
  let t2;
  if ($[0] !== className) {
    t2 = cn("relative inline-flex items-center gap-1 text-sm text-gray-600", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg aria-hidden="true" className="h-4 w-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== setShowPopup || $[4] !== showPopup) {
    t4 = () => setShowPopup(!showPopup);
    $[3] = setShowPopup;
    $[4] = showPopup;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return <div ref={containerRef} className={t2} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t3}<button type="button" className="cursor-pointer text-left hover:underline focus:underline focus:outline-none" onClick={t4} aria-expanded={showPopup} aria-haspopup="dialog"><span>{t("reviews.verifiedCollectedBy", {
          business: businessName
        })}</span></button>{showPopup && <div className="absolute top-full left-0 z-50 mt-2 w-80 rounded-lg border border-gray-200 bg-white p-4 shadow-lg" role="dialog" aria-modal="false"><p className="text-sm text-gray-700">{t("reviews.verifiedExplainer")}{" "}<a href="https://corporate.trustpilot.com/trust?utm_medium=Trustbox&utm_source=ProductListImportedSEO" target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 underline hover:text-blue-800">{t("reviews.verifiedLearnMore")}</a></p></div>}</div>;
};